<template lang='pug'>
  .view-container
    .content-container
      .title.center What would you like to do?

      router-link.link-item.disabled(:to="{name:'select'}")
        .icon
          include ../assets/icons/camera.svg
        .text Take a photo

      router-link.link-item.disabled(:to="{name:'select'}")
        .icon
          include ../assets/icons/image.svg
        .text Upload a photo

      router-link.link-item.disabled(:to="{name:'results'}")
        .icon
          include ../assets/icons/bar-graph.svg
        .text View previous results

      //- router-link.link-item.disabled(:to="{name:'home'}")
        .icon
          include ../assets/icons/info.svg
        .text Learn about the app

      .link-item(@click='$store.commit("toggleTheme")')
        .icon
          include ../assets/icons/network.svg
        .text Toggle Indigo mode
</template>

<script>
export default {
  
}
</script>

<style scoped lang="sass">
@import ../sass/variables
.title
  padding-bottom: 0.8em
.view-container
  display: flex
  justify-content: center
  align-items: center
  .center-container

.link-item
  display: flex
  justify-content: flex-start
  align-items: center
  text-decoration: none
  background-color: transparent
  padding-left: 2em
  padding-right: 3em
  margin: 0.4em 0
  border-radius: $border-radius-small
  cursor: pointer
  transition: padding 0.5s
  &, *
    user-select: none

  .icon
    padding: 0 0.8em
    padding-top: 0.2em
    padding-left: 0

  .text
    font-size: $font-size-1

  .icon svg *, .text
    fill: var(--fg1)
    color: var(--fg1)

  &:hover
    transition: 0.2s all
    background-color: var(--ac1)
    padding-top: 1em
    padding-bottom: 1em
    .icon svg *, .text
      fill: var(--ac1c)
      color: var(--ac1c)

</style>
